import React, { useState, useEffect, Fragment } from 'react';
import {
  Row,
  Input,
  FormGroup,
  Label,
  CustomInput,
  Button,
  ButtonGroup,
  Form,
  Modal,
  ModalBody,
  InputGroup,
} from 'reactstrap';
import {
  Colxx,
  Separator,
} from '../../../../../../components/common/CustomBootstrap';
import { AxiosAPI, AxiosPublicAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import {
  gAPI_Property_List_By_Group,
  API_SABRE,
  gAPI_Ingetration,
  API_PARTNER_SABRE,
  postAPI_Sync_Room,
} from '../../../../../../constants/APIs';
import { NotificationManager } from '../../../../../../components/common/react-notifications';
import { Tooltip } from 'reactstrap';
import Validation from '../../../../../../components/Validation';
let arr = [];
export default function SabreIntegration({ visible, toggle, id }) {
  const [property, setProperty] = useState([]);
  const [open, setOpen] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [msg, setMsg] = useState([]);
  const [maskData, setMaskData] = useState({
    UserName: '',
    Password: '',
  });
  const [titleToolTip, settitleToolTip] = useState(false);
  const [showRatesRadios, setRatesRadios] = useState(false);
  const [inputData, setInputData] = useState({
    GroupId: getGroupID(),
    Name: 'SynXis',
    Properties: [],
    SessionTimeoutInSeconds: 600,
    DefaultLanguage: 'en-US',
    UserName: '',
    Password: '',
    HotelCode: '',
    Domain: '',
    ShowRates: false,
    ShowAvailability: false,
    ShowRatesAllRoom: false,
    ShowRatesSelectedRoom: false,
    RatePlanCode: '',
    ChannelCode: '',
    ChannelId: '',
  });
  const toggleTitleToolTip = () => {
    settitleToolTip(!titleToolTip);
  };
  useEffect(() => {
    if (id !== undefined) {
      AxiosAPI({
        method: 'get',
        url: `${API_SABRE}/${id}?group_id=${getGroupID()}`,
      })
        .then((res) => {
          setInputData({
            ...inputData,
            Name: res.data.name,
            Properties:
              res.data.properties !== null ? [res.data.properties[0]] : [],
            UserName: res.data.channelDetails.userName,
            Password: res.data.channelDetails.password,
            Domain: res.data.channelDetails.domain,
            HotelCode: res.data.channelDetails.hotelCode,
            ChannelCode: res.data.channelDetails.channelCode,
            ChannelId: res.data.channelDetails.channelId,
            ShowRates: res.data.channelDetails.showRates,
            ShowAvailability: res.data.channelDetails.showAvailability,
            ShowRatesAllRoom: res.data.channelDetails.showRatesAllRoom,
            ShowRatesSelectedRoom:
              res.data.channelDetails.showRatesSelectedRoom,
            RatePlanCode: res.data.channelDetails.ratePlanCode,
          });

          if (res.data.channelDetails.showRates === true) {
            setRatesRadios(true);
          }

          setMaskData({
            ...maskData,
            UserName: mask(res.data.channelDetails.userName),
            Password: mask(res.data.channelDetails.password),
          });
        })
        .catch((err) => console.log('err', err));

      AxiosAPI({
        method: 'get',
        url: `${gAPI_Property_List_By_Group}/?group_id=${getGroupID()}`,
      })
        .then((res) => {
          setProperty([...res.data]);
        })
        .catch((err) => console.error(err));
    } else {
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Property_List_By_Group}/?group_id=${getGroupID()}`,
      })
        .then((res) => {
          setProperty([...res.data]);
        })
        .catch((err) => console.error(err));
    }
  }, [id]);
  const mask = (value) => {
    let maskedValue = '';
    for (let i = 0; i < value.length - 2; i++) {
      maskedValue += '*';
    }
    return maskedValue + value.substring(value.length - 2, value.length);
  };

  const handleNameChange = (e) => {
    e.persist();
    setInputData({ ...inputData, Name: e.target.value });
  };

  const handleRateChange = (e) => {
    if (e.target.checked === true) {
      setRatesRadios(true);
      if (
        inputData.ShowRatesAllRoom === false &&
        inputData.ShowRatesSelectedRoom === false
      ) {
        setInputData({ ...inputData, ShowRatesAllRoom: e.target.checked });
      }
    } else {
      setRatesRadios(false);
    }
    setInputData({ ...inputData, ShowRates: e.target.checked });
  };

  const handleShowAllChange = (e) => {
    if (e.target.checked === true) {
      setInputData({
        ...inputData,
        ShowRatesAllRoom: e.target.checked,
        ShowRatesSelectedRoom: false,
      });
    } else {
      setInputData({ ...inputData, ShowRatesAllRoom: e.target.checked });
    }
  };

  const handleShowSelectedChange = (e) => {
    if (e.target.checked === true) {
      setInputData({
        ...inputData,
        ShowRatesSelectedRoom: e.target.checked,
        ShowRatesAllRoom: false,
      });
    } else {
      setInputData({ ...inputData, ShowRatesSelectedRoom: e.target.checked });
    }
  };

  const handleAvailabilityChange = (e) => {
    setInputData({ ...inputData, ShowAvailability: e.target.checked });
  };

  const handleRatePlanChangeChange = (e) => {
    setInputData({ ...inputData, RatePlanCode: e.target.value });
  };

  const handleApiKeyChange = (e) => {
    setSuccessMessage('');
    e.persist();
    setMaskData({ ...maskData, UserName: mask(e.target.value) });
    setInputData({ ...inputData, UserName: e.target.value });
    //console.log(inputData)
  };
  const handlePasswordChange = (e) => {
    setSuccessMessage('');
    e.persist();
    setMaskData({ ...maskData, Password: mask(e.target.value) });
    setInputData({ ...inputData, Password: e.target.value });
    //console.log(inputData)
  };
  const handleHotelDetailsChange = (e) => {
    setSuccessMessage('');
    e.persist();
    setInputData({ ...inputData, [e.target.name]: e.target.value });
  };
  const handleDomainChange = (e) => {
    setSuccessMessage('');
    e.persist();
    setInputData({ ...inputData, Domain: e.target.value });
  };
  const handleCheckChange = (e) => {
    const selectedPropertyId = e.target.value;
    const selectedProperty = property.find((p) => p.id === selectedPropertyId);

    if (e.target.checked && selectedProperty) {
      setInputData({
        ...inputData,
        Properties: [selectedPropertyId],
        Name: `SynXis – ${selectedProperty.name}`,
      });
    }

    if (!e.target.checked) {
      setInputData({
        ...inputData,
        Properties: [],
        Name: 'SynXis',
      });
    }
  };

  const validateRequest = () => {
    setSuccessMessage('');
    let data = { ...inputData };
    console.log(inputData, data);
    AxiosPublicAPI({
      method: 'post',
      url: `${API_PARTNER_SABRE}/validate`,
      data: {
        userName: inputData?.UserName,
        password: inputData?.Password,
        channelId: inputData?.ChannelId,
        hotelCode: inputData?.HotelCode,
        channelCode: inputData?.ChannelCode,
        domain: inputData?.Domain,
      }
    }).then((res) => {
      console.log(res.data);
      if (res.data.length > 0) {
        setSuccessMessage('Connection Successfully Established.');
      } else {
        setSuccessMessage('Please enter the correct credentials.');
      }
    });
  };
  const handleSave = async () => {
    setSuccessMessage('');
    if (id !== undefined) {
      AxiosAPI({
        method: 'put',
        url: `${API_SABRE}/${id}?group_id=${getGroupID()}`,
        data: inputData,
      }).then((res) => {
        if (
          res.data.HttpStatusCode !== undefined &&
          res.data.HttpStatusCode === 400 &&
          res.data.Messages !== undefined &&
          res.data.Messages !== null &&
          res.data.Messages.length > 0
        ) {
          setMsg(res.data.Messages);
          setOpen(true);
        } else {
          toggle();
          setTimeout(() => {
            //window.location.reload();
          }, 300);
        }
      });
    } else {
      AxiosAPI({
        method: 'post',
        url: API_SABRE,
        data: inputData,
      }).then((res) => {
        if (
          res.data.HttpStatusCode !== undefined &&
          res.data.HttpStatusCode === 400 &&
          res.data.Messages !== undefined &&
          res.data.Messages !== null &&
          res.data.Messages.length > 0
        ) {
          setMsg(res.data.Messages);
          setOpen(true);
        } else {
          toggle();
          setTimeout(() => {
            // window.location.reload();
          }, 300);
        }
      });
    }
  };

  return (
    <Fragment>
      <Modal isOpen={visible} toggle={toggle}>
        <ModalBody>
          <Row className="mb-4">
            <Colxx xxs="12">
              <div className="text-center">
                <h6>
                  {id === undefined ? 'Add' : 'Update'} SynXis Channel Connect
                  Integration
                </h6>
                <p>
                  Add your Channel Connect credentials to establish connection.
                  This will allow your AI Knowledge Hub to pull hotel
                  description and availability/rates from SynXis.
                </p>
                <Separator className="mb-3" />
                <Form className="text-left">
                  <FormGroup className="mb-2">
                    <Label>Integration Name</Label>
                    <Input
                      type="text"
                      name="integrationName"
                      value={inputData.Name}
                      readOnly
                      placeholder="SynXis"
                    />
                  </FormGroup>
                  <FormGroup className="mb-2">
                    <Label>User Name</Label>
                    <Input
                      type="text"
                      name="UserName"
                      onChange={handleApiKeyChange}
                      placeholder="User Name"
                      defaultValue={maskData.UserName}
                    />
                  </FormGroup>
                  <FormGroup className="mb-2">
                    <Label>Password</Label>
                    <Input
                      type="text"
                      name="Password"
                      onChange={handlePasswordChange}
                      placeholder="Password"
                      defaultValue={maskData.Password}
                    />
                  </FormGroup>
                  <FormGroup className="mb-2">
                    <Label>Hotel Code</Label>
                    <Input
                      type="text"
                      name="HotelCode"
                      onChange={handleHotelDetailsChange}
                      placeholder="Hotel Code"
                      defaultValue={inputData.HotelCode}
                    />
                  </FormGroup>
                  <FormGroup className="mb-2">
                    <Label>Domain</Label>
                    <Input
                      type="text"
                      name="Domain"
                      onChange={handleDomainChange}
                      placeholder="Domain"
                      defaultValue={inputData.Domain}
                    />
                  </FormGroup>
                  <FormGroup className="mb-2">
                    <Label>Channel Code</Label>
                    <Input
                      type="text"
                      name="ChannelCode"
                      onChange={handleHotelDetailsChange}
                      placeholder="Channel Code"
                      defaultValue={inputData.ChannelCode}
                    />
                  </FormGroup>
                  <FormGroup className="mb-2">
                    <Label>Channel Id</Label>
                    <Input
                      type="text"
                      name="ChannelId"
                      onChange={handleHotelDetailsChange}
                      placeholder="Channel Id"
                      defaultValue={inputData.ChannelId}
                    />
                  </FormGroup>
                  <Separator className="mb-3" />
                  <FormGroup className="mb-2" style={{ display: 'none' }}>
                    <div className="">
                      <CustomInput
                        key="ShowAvailability"
                        type="checkbox"
                        label="Show Availability Summary in Rooms View"
                        name="ShowAvailability"
                        checked={inputData.ShowAvailability}
                        onChange={handleAvailabilityChange}
                      />
                    </div>
                  </FormGroup>
                  <FormGroup className="mb-3">
                    <div className="">
                      <CustomInput
                        key="showRates"
                        type="checkbox"
                        label="Show Rates & Availability in AI Chatbot Calendar"
                        name="showRates"
                        checked={inputData.ShowRates}
                        onChange={handleRateChange}
                      />
                    </div>
                  </FormGroup>
                  <p>Select the property this integration applies to:</p>
                  {showRatesRadios && (
                    <Fragment>
                      {' '}
                      <FormGroup className="mb-1 ml-5">
                        <div className="">
                          <CustomInput
                            key={'showallrooms'}
                            type="radio"
                            label={'Show Lowest Rate Among All Rooms'}
                            name="showRatesAllRoom"
                            checked={inputData.ShowRatesAllRoom}
                            onChange={handleShowAllChange}
                          />
                        </div>
                      </FormGroup>
                      <FormGroup className="mb-1 ml-5">
                        <div className="">
                          <CustomInput
                            key={'showselectedrooms'}
                            type="radio"
                            label={'Show Lowest Rate For The Selected Room'}
                            name="showRatesSelectedRoom"
                            checked={inputData.ShowRatesSelectedRoom}
                            onChange={handleShowSelectedChange}
                          />
                        </div>
                      </FormGroup>
                      <FormGroup className="mb-1">
                        <div className="">
                          <Label className="mt-3">
                            Use Specific Rate Plan To Fetch Rates{' '}
                            <i
                              className="demo-icon simple-icon-info"
                              id="titletip"
                            ></i>
                          </Label>
                          <Tooltip
                            placement="right"
                            isOpen={titleToolTip}
                            target="titletip"
                            toggle={toggleTitleToolTip}
                          >
                            Copy the rate plan from iHotelier to the field
                            below, this is usually the rate plan you have
                            specifically created for Myma.ai
                          </Tooltip>
                          <Input
                            type="text"
                            onChange={handleRatePlanChangeChange}
                            value={inputData.RatePlanCode}
                            name="RatePlanCode"
                            maxLength={50}
                            placeholder={'Rate Plan Code'}
                          />
                        </div>
                      </FormGroup>
                    </Fragment>
                  )}

                  <FormGroup className="mb-2">
                    <div className="integration-property">
                      {property.map((p, index) => {
                        return (
                          <CustomInput
                            key={p.id}
                            type="radio"
                            id={index}
                            label={p.name}
                            value={p.id}
                            name="property"
                            checked={
                              p.id === inputData.Properties[0] ? true : false
                            }
                            onChange={handleCheckChange}
                          />
                        );
                      })}
                    </div>
                  </FormGroup>
                </Form>
                <ButtonGroup className="mb-2" style={{ marginTop: '20px' }}>
                  {id === undefined ? (
                    <Button color="primary" size="xs" onClick={handleSave}>
                      Create New Integration
                    </Button>
                  ) : (
                    <Button color="primary" size="xs" onClick={handleSave}>
                      Update Integration
                    </Button>
                  )}
                  <Button size="xs" color="dark" outline onClick={toggle}>
                    Cancel
                  </Button>
                  <Button
                    color="dark"
                    size="xs"
                    outline
                    onClick={validateRequest}
                  >
                    Validate Request
                  </Button>
                </ButtonGroup>
              </div>
            </Colxx>
            <Colxx className="text-center">
              {successMessage !== undefined && successMessage !== '' && (
                <Fragment>
                  {successMessage ===
                    'Connection Successfully Established.' && (
                      <span style={{ color: 'green' }}>
                        Connection Successfully Established.
                      </span>
                    )}
                  {successMessage ===
                    'Please enter the correct credentials.' && (
                      <span style={{ color: 'red' }}>
                        Please enter the correct credentials.
                      </span>
                    )}
                </Fragment>
              )}
            </Colxx>
          </Row>
        </ModalBody>
      </Modal>
      <Validation
        open={open}
        messages={msg}
        toggle={() => {
          setOpen(!open);
        }}
      ></Validation>
    </Fragment>
  );
}
